import { render, staticRenderFns } from "./VueFlip.vue?vue&type=template&id=3c3264dc&"
import script from "./VueFlip.vue?vue&type=script&lang=js&"
export * from "./VueFlip.vue?vue&type=script&lang=js&"
import style0 from "./VueFlip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports